import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@auth-guards/auth.guard';
import { ThemeComponent } from '@theme/theme.component';


const routes: Routes = [
  {
    'path': '',
    'component': ThemeComponent,
    'canActivate': [AuthGuard],
    'children': [
      {
        'path': 'index',
        'loadChildren': () => import('./pages/default/index/index.module').then(m => m.IndexModule)
      },
      {
        'path': 'header\/profile',
        'loadChildren': () => import('./pages/default/header/header-profile/header-profile.module').then(m => m.HeaderProfileModule)
      },
      /*VBT Ticari Link Begin*/
      {
        'path': 'Financial',
        'loadChildren': () => import('../vbt-ticari/Financial/Financial.module').then(m => m.FinancialModule)
      },
      {
        'path': 'Parameters',
        'loadChildren': () => import('../vbt-ticari/Parameters/parameters.module').then(m => m.ParametersModule)
      },
      {
        'path': 'GlobalSearch',
        'loadChildren': () => import('../vbt-ticari/GlobalSearch/GlobalSearch.module').then(m => m.GlobalSearchModule)
      },
      {
        'path': 'Invoice',
        'loadChildren': () => import('../vbt-ticari/Invoice/Invoice.module').then(m => m.InvoiceModule)
      },
      {
        'path': 'DespatchAdvice',
        'loadChildren': () => import('../vbt-ticari/DespatchAdvice/DespatchAdvice.module').then(m => m.DespatchAdviceModule)
      },
      {
        'path': 'SMM',
        'loadChildren': () => import('../vbt-ticari/SMM/SMM.module').then(m => m.SMMModule)
      },
      {
        'path': 'EMM',
        'loadChildren': () => import('../vbt-ticari/EMM/EMM.module').then(m => m.EMMModule)
      },
       {
        'path': 'ExpenseVoucher',
        'loadChildren': () => import('../vbt-ticari/ExpenseVoucher/ExpenseVoucher.module').then(m => m.ExpenseVoucherModule)
      },
      {
        'path': 'Report',
        'loadChildren': () => import('../vbt-ticari/Report/ReportInvoice.module').then(m => m.ReportInvoiceModule)
      },
      {
        'path': 'Migration',
        'loadChildren': () => import('../vbt-ticari/Migration/Migration.module').then(m => m.MigrationModule)
      },
      {
        'path': 'Ticket',
        'loadChildren': () => import('../vbt-ticari/Ticket/Ticket.module').then(m => m.TicketModule)
      },
      {
        'path': 'Bill',
        'loadChildren': () => import('../vbt-ticari/Bill/Bill.module').then(m => m.BillModule)
      },
      {
        'path': 'GibReport',
        'loadChildren': () => import('../vbt-ticari/GibReport/GibReport.module').then(m => m.GibReportModule)
      },
      /*VBT Ticari Link End*/
      /*VBT BackOffice Link Begin*/
      {
        'path': 'Role',
        'loadChildren': () => import('../vbt-back-office/Role/Role.module').then(m => m.RoleModule)
      },
      {
        'path': 'Customer',
        'loadChildren': () => import('../vbt-back-office/Customer/Customer.module').then(m => m.CustomerModule)
      },
      {
        'path': 'Cache',
        'loadChildren': () => import('../vbt-back-office/Cache/Cache.module').then(m => m.CacheModule)
      },
      {
        'path': 'Menu',
        'loadChildren': () => import('../vbt-back-office/Menu/Menu.module').then(m => m.MenuModule)
      },
      {
        'path': 'Job',
        'loadChildren': () => import('../vbt-back-office/Job/Job.module').then(m => m.JobModule)
      },
      /*VBT BackOffice Link End*/
      /*VBT Support Team Link Begin*/
      {
        'path': 'Support',
        'loadChildren': () => import('../vbt-ticari/Support/Support.module').then(m => m.SupportModule)
      },
      {
        'path': 'DynamicWorkflow',
        'loadChildren': () => import('../vbt-ticari/DynamicWorkflow/DynamicWorkflow.module').then(m => m.DynamicWorkflowModule)
      },
      {
        'path': 'UnauthorizedAccess',
        'loadChildren': () => import('./pages/default/UnauthorizedAccess/UnauthorizedAccess.module').then(m => m.UnauthorizedAccessModule)
      },
      /*VBT Support Team End*/
      {
        'path': '404',
        'loadChildren': () => import('./pages/default/not-found/not-found.module').then(m => m.NotFoundModule)
      },
      {
        'path': '',
        'redirectTo': 'index',
        'pathMatch': 'full'
      }
    ]
  },
  {
    'path': 'Preview',
    'loadChildren': () => import('../vbt-ticari/Preview/Preview.module').then(m => m.PreviewModule)
  },
  {
    'path': '**',
    'redirectTo': '404',
    'pathMatch': 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class ThemeRoutingModule {
}
